import Footer from './Footer';
import withUser from '../context/withUser';

export default withUser(Footer);



// WEBPACK FOOTER //
// ./src/components/common/FooterContainer.js